import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';

export const GET_USER_STATE_REQUEST = 'GET_USER_STATE_REQUEST';
export const GET_USER_STATE_SUCCESS = 'GET_USER_STATE_SUCCESS';
export const GET_USER_STATE_ERROR = 'GET_USER_STATE_ERROR';

export function getUserStateAction() {
	return { type: GET_USER_STATE_REQUEST };
}

export function getUserStateSuccessAction(data) {
	return { type: GET_USER_STATE_SUCCESS, data };
}

export function getUserStateErrorAction(error) {
	return { type: GET_USER_STATE_ERROR, error };
}

// This function is used in both checkout and header, which are client-side
// calls, and is called without any args.
export function fetchUserStateAction(requestHeaders, url) {
	return dispatch => {
		dispatch(getUserStateAction());
		const data = {
			abDataId: -1,
			ad: {
				adId: requestHeaders && requestHeaders['Cookie'],
				doNotPersonalizeAds: false
			}
		};
		if (url) {
			Object.assign(data, {
				channelTaggingInfo: {
					landingPageUrl: url
				}
			});
		}

		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/user/state',
				action: GET_USER_STATE_REQUEST,
				headers: Object.assign({}, headers, requestHeaders),
				acceptErrors: true
			}),
			data
		).then(
			response => {
				dispatch(getUserStateSuccessAction(response));
				return response;
			},
			err => {
				let errorObj = err;
				if (typeof err === 'string' && err.includes('Request timeout:')) {
					errorObj = {
						ERROR_MESSAGE: 'Request took longer than expected. Failed reason: TIMEDOUT',
						ERROR_CODE: 408
					};
				}
				dispatch(getUserStateErrorAction(errorObj));
				return Promise.reject(err);
			}
		);
	};
}
